export class CookieBanner {
  static init(): void {
    if (localStorage.getItem('arcade_cookie_consent') === 'true') return;

    const banner = document.createElement('div');
    banner.id = 'cookie-banner';
    banner.style.cssText = `
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background: rgba(15, 23, 42, 0.95);
      border-top: 1px solid #334155;
      padding: 16px 24px;
      z-index: 9999;
      display: flex;
      justify-content: space-between;
      align-items: center;
      backdrop-filter: blur(10px);
      box-shadow: 0 -10px 25px rgba(0,0,0,0.5);
    `;

    banner.innerHTML = `
      <div style="display: flex; align-items: center; gap: 12px; max-width: 800px;">
        <span style="font-size: 1.5rem;">🍪</span>
        <p style="color: #94a3b8; font-size: 0.88rem; line-height: 1.4;">
          Sitemizde deneyiminizi geliştirmek ve kişiselleştirilmiş Google AdSense reklamları sunmak için çerezler (cookies) kullanıyoruz. 
          <a href="#/privacy" style="color: #818cf8; text-decoration: underline;">Gizlilik Politikası</a>
        </p>
      </div>
      <div style="display: flex; gap: 10px; shrink: 0;">
        <button id="accept-cookies-btn" style="padding: 10px 20px; background: linear-gradient(135deg, #6366f1, #8b5cf6); color: #fff; border-radius: 8px; font-weight: 700; font-size: 0.88rem;">
          Kabul Et
        </button>
      </div>
    `;

    document.body.appendChild(banner);

    document.getElementById('accept-cookies-btn')?.addEventListener('click', () => {
      localStorage.setItem('arcade_cookie_consent', 'true');
      banner.remove();
    });
  }
}
